/**
 * One line telling you what the current scope view contains.
 * For Media Devoted | Created By Ciro Autiero
 *
 * A scope with nothing overridden looks almost identical to Default, so silence
 * here reads as "the selector did nothing" — which is exactly how it was
 * reported. Say it plainly instead.
 */

import type { FC } from 'react';

import type { ScopeTarget } from '../model';

export const ScopeSummary: FC<{ target: ScopeTarget; countLabel: number }> = ({
  target,
  countLabel,
}) => {
  const level = target === 'campaign' ? 'campaign' : 'country';
  if (countLabel > 0) {
    return (
      <span className="ml-auto text-[11px] leading-tight text-muted-foreground">
        <strong className="text-foreground">{countLabel}</strong>{' '}
        {countLabel === 1 ? 'condition uses' : 'conditions use'} this {level}&apos;s value ·
        editing a rule writes the {level} value
      </span>
    );
  }
  return (
    <span className="ml-auto text-[11px] leading-tight text-muted-foreground">
      Nothing overrides this {level} yet — every rule below shows what it inherits.
      Editing one writes a {level} value.
    </span>
  );
};
